import { Component, Input, OnInit } from '@angular/core';
import { CustomBuilderComponent } from 'src/app/core/decorators';
import { JebbitProduct } from 'src/app/core/interfaces/jebbit.interface';
import { JebbitService } from './../../../services/jebbit.service';
import { AppRecommendedComparisonComponent } from './comparison-element/comparison-element.component';
import { NgClass } from '@angular/common';

export const comparisonSeriesComponentConfig = {
  tag: 'app-cc-series-comparison',
  name: 'comparison between series table',
  inputs: [
    {
      name: 'first_jebbitID',
      type: 'string',
      helperText: 'First default selected in the table',
    },
    {
      name: 'second_jebbitID',
      type: 'string',
      helperText: 'Second default selected in the table',
    },
    {
      name: 'third_jebbitID',
      type: 'string',
      helperText: 'Third default selected in the table',
    },
    {
      name: 'bazaarvoiceReviews',
      type: 'boolean',
      helperText: 'This option will enable the reviews from contentful and bazaarvoice element in the table.',
    },
    /**
     * Typo error
     * @deprecated
     */
    {
      name: 'bazarvoiceReviews',
      type: 'boolean',
      helperText:
        'DEPRECATED use bazaarvoiceReviews: This option will enable the reviews from contentful and bazarvoice element in the table.',
    },
  ],
};

@Component({
  standalone: true,
  imports: [NgClass, AppRecommendedComparisonComponent],
  selector: 'app-recommended-comparison-table',
  templateUrl: './comparison-serie.component.html',
  styleUrls: ['./comparison-serie.styles.scss'],
})
@CustomBuilderComponent(comparisonSeriesComponentConfig)
export class AppComparisonSeriesComponent implements OnInit {
  /** If the data comes directly from angular. */
  @Input() products: JebbitProduct[] = [];
  @Input() selectedProducts: JebbitProduct[] = [];

  /** If the data comes directly from contentful */
  @Input() first_jebbitID: string = '';
  @Input() second_jebbitID: string = '';
  @Input() third_jebbitID: string = '';

  /**
   * @deprected use bazaarvoiceReviews
   */
  @Input() bazarvoiceReviews: boolean = true;
  @Input() bazaarvoiceReviews: boolean = true;
  @Input() isHubPage = true;
  public AccesoriesOpen = false;
  public ModesOpen = false;

  constructor(private jebbitService: JebbitService) {}

  ngOnInit(): void {
    /** This means that the data has to come from builder instead of angular. */
    if (this.products.length == 0) {
      this.jebbitService.jebbitData$.subscribe((res) => {
        if (res.products.length == 0) {
          return this.jebbitService.getJebbitDataFromContentful(false);
        }

        this.products = res.products;
        return this.getSelectedProducts();
      });
    }
  }

  getSelectedProducts(): void {
    this.selectedProducts = [
      this.findEntry(this.first_jebbitID),
      this.findEntry(this.second_jebbitID),
      this.findEntry(this.third_jebbitID),
    ];
  }

  findEntry(jebbitID: string): JebbitProduct {
    const product = this.products.find((element) => element.fields.jebbitId == jebbitID);
    if (product) {
      return product;
    }
    // FALLBACK AS FIRST PRODUCT
    return this.products[0];
  }

  changeDisplay(event: any) {
    this.AccesoriesOpen = event;
  }
  changeModesDisplay(event: any) {
    this.ModesOpen = event;
  }
}
